import React from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

export const ScrollContext = React.createContext<OverlayScrollbarsComponent | null>(
  null
);
